module.exports = __webpack_public_path__ + "advanced2.png?6d1654c3baee0ed46396833f882c0027";